import { connect } from "react-redux";
import { token } from "../../../../modules/auth";
import { getFormValues } from "redux-form";
import React, { useEffect } from "react";
import { Cell, GroupHeader, RowHeader, TR } from "../clean-table";
import { createRangeYearToDate } from "../date-utils";
import getDatesArray from "../../../../modules/analytics/get-dates-array";
import { detailedEngagements } from "../../../../modules/analytics";
import {
  agentRfpItemsUnload,
  fetchAgentRfpItems,
} from "../../../../redux/actions";
import { ButtonBrand } from "../../../../Components/Button";

const PAGE_SIZE = 20;
const mapStateToProps = (state, props) => {
  const v = getFormValues("analytics")(state) || {};
  let dates = getDatesArray(
    createRangeYearToDate().start,
    createRangeYearToDate().end
  );
  return {
    token: token(state),
    agentRfps: state.reportingFigures.agentRfps,
    isFetching: state.reportingFigures.isFetching,
    stats: detailedEngagements(
      v.venue_id,
      createRangeYearToDate().start,
      createRangeYearToDate().end
    )(state),
    venues: v.venues,
    startDate:
      typeof props.startDate !== "undefined" ? props.startDate : v.start_date,
    endDate: typeof props.endDate !== "undefined" ? props.endDate : v.end_date,
  };
};

const mapDispatchToProps = {
  fetchAgentRfpItems,
  agentRfpItemsUnload,
};

const AgencyViews = props => {
  const [showAll, setShowAll] = React.useState(false);
  useEffect(() => {
    props.fetchAgentRfpItems(
      props.venues,
      props.startDate,
      props.endDate,
      props.type,
      props.token
    );
  }, []);

  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  let agencyGroups = [];
  let agencyGroupsI = [];
  if (
    props.engagementViews.length === 0 && props.engagementInteractions.length === 0 &&
    (!props.agentRfps || props.agentRfps.length === 0)
  ) {
    return <div>No Agency Engagements</div>;
  }

  if (props.engagementViews.length !== 0) {
    let usersGroups = groupBy(props.engagementViews, "user_type");
    if (usersGroups && usersGroups["Agency"]) {
      agencyGroups = groupBy(usersGroups["Agency"], "user_company");
    }
  }
  if (props.engagementInteractions.length !== 0) {
    let usersGroupsI = groupBy(props.engagementInteractions, "user_type");
    if (usersGroupsI && usersGroupsI["Agency"]) {
      agencyGroupsI = groupBy(usersGroupsI["Agency"], "user_company");
    }
  }

  let agenciesAdded = [];

  let agenciesAddedI = [];
  if (props.agentRfps && props.agentRfps.length > 0) {
    for (const [key, value] of Object.entries(
      groupBy(props.agentRfps, "company")
    )) {
      let engagementCount = 0;
      if (agencyGroupsI && agencyGroupsI[key]) {
        engagementCount += agencyGroupsI[key].length;
      }
      if (key !== "null" && key !== "") {
        agenciesAddedI.push({
          key: key,
          count: value.length + engagementCount,
        });
      }
    }
  }
  if (props.engagementViews.length !== 0) {
    for (const [key, value] of Object.entries(agencyGroups)) {
      if (
        !agenciesAdded.find(company => company.key === key) &&
        key !== "null" &&
        key !== ""
      ) {
        agenciesAdded.push({
          key: key,
          count: value.length,
        });
      }
      if (
        !agenciesAdded.find(company => company.key === key) &&
        key === "null"
      ) {
        let other = agenciesAdded.find(company => company.key === "Other");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          agenciesAdded.push({
            key: "Other",
            count: value.length,
          });
        }
      }

      if (!agenciesAdded.find(company => company.key === key) && key === "") {
        let other = agenciesAdded.find(company => company.key === "");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          agenciesAdded.push({
            key: "Other",
            count: value.length,
          });
        }
      }
    }
  }
  if (props.engagementInteractions.length !== 0) {
    for (const [key, value] of Object.entries(agencyGroupsI)) {
      if (
        !agenciesAddedI.find(company => company.key === key) &&
        key !== "null" &&
        key !== ""
      ) {
        agenciesAddedI.push({
          key: key,
          count: value.length,
        });
      }
      if (
        !agenciesAddedI.find(company => company.key === key) &&
        key === "null"
      ) {
        let other = agenciesAddedI.find(company => company.key === "Other");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          agenciesAddedI.push({
            key: "Other",
            count: value.length,
          });
        }
      }

      if (!agenciesAddedI.find(company => company.key === key) && key === "") {
        let other = agenciesAddedI.find(company => company.key === "");
        if (other?.length > 0) {
          other.count += value.length;
        } else {
          agenciesAddedI.push({
            key: "Other",
            count: value.length,
          });
        }
      }
    }
  }
  if (agenciesAdded.length === 0 && agenciesAddedI.length === 0) {
    return <div>No Agency Engagements</div>;
  }
  let mergedAdded = [];
  agenciesAdded.map((added) => {{
    mergedAdded.push({
      key: added.key,
      views: added.count,
      interactions: 0
    })
  }});
  agenciesAddedI.map((added) => {
    let companyExists = mergedAdded.findIndex((element) => {
      return element.key === added.key
    })
    if(companyExists !== -1){
      mergedAdded[companyExists] = {
        ...mergedAdded[companyExists],
        interactions: added.count
      }
    }else{
      mergedAdded.push({
        key: added.key,
        views: 0,
        interactions: added.count
      })
    }
  })
  return (
    <table>
      <thead>
        <tr>
          <GroupHeader colSpan={2} className="w-1/4">
            Agency
          </GroupHeader>
          <GroupHeader colSpan={2} className="w-1/4 text-center">
            Views
          </GroupHeader>
          <GroupHeader colSpan={2} className="w-1/4 text-center">
            Interactions
          </GroupHeader>
        </tr>
      </thead>
      <tbody className={"text-xl"}>
        <>
          {mergedAdded
            .sort((a, b) => b.count - a.count)
            .map((company, index) => {
              if (showAll || index < PAGE_SIZE) {
                return (
                  <TR key={company.key}>
                    {window.BASE_URL !== 'https://demo.edgevenues.com' ? <Cell colSpan={2}>{company.key}</Cell> :<Cell colSpan={2}>Agency {index}</Cell>}
                    <Cell colSpan={2} className={'text-center'}>{company.views}</Cell>
                    <Cell colSpan={2} className={'text-center'}>{company.interactions}</Cell>
                  </TR>
                );
              }
            })}
        </>
        {agenciesAdded.length > PAGE_SIZE ? (
          <div className={"pt-5"}>
            <ButtonBrand onClick={() => setShowAll(!showAll)}>
              {showAll ? "Hide All" : "Show All"}
            </ButtonBrand>
          </div>
        ) : (
          <></>
        )}
      </tbody>
    </table>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyViews);
